// @flow
const selected = {
  background: '#eb6e1f',
};

export default { selected };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Medication/components/MedicationInput/components/DaySelector/style.js